export default ({ request }) => ({
    orderIdentifyCodeListApi(data = {}) {
      return request({
        url: "/factory/orderIdentify/code/list",
        method: "post",
        data,
      });
    },
  });
  